import React, { useState } from 'react';
import { Transforms } from 'slate';
import { useSlate, ReactEditor } from 'slate-react';
import ExampleLabelPreviewContainer from './ExampleLabelPreviewContainer';
import { makeStyles } from 'react-scale/components/design-system/styles';
// eslint-disable-next-line restrict-imports/restrict-imports
import theme from 'design-system/product/theme';

interface LabelSectionProps {
  attributes: $FIXME;
  children: Record<string, any>[];
  element: $FIXME;
  location: any;
  readOnly: boolean;
  setLocation: (arg: any) => void;
  setExampleModalOpen?: (arg: any) => void;
  setExampleSelectionGridOpen?: (arg: any) => void;
  hasOpenedExample?: (taskId: string, isGoodExample: boolean) => void;
  projectTemplateId?: string;
  isMigration?: boolean;
}

export const LabelSection: React.FC<LabelSectionProps> = ({
  attributes,
  children,
  element,
  readOnly,
  location,
  setLocation,
  setExampleModalOpen,
  setExampleSelectionGridOpen,
  hasOpenedExample,
  projectTemplateId,
  isMigration,
}) => {
  const classes = useStyles();
  const editor = useSlate();
  const { labelName, examples } = element;

  const [showExamples, toggleExamples] = useState(examples.length < 10);
  const [labelNameState, setLabelName] = useState(labelName);

  const handleDeleteExample = (taskId: string) => {
    if (readOnly) return;
    const path = ReactEditor.findPath(editor, element);
    const newExamples = examples.filter((elem: Record<string, any>) => elem.taskId !== taskId);
    // @ts-ignore
    Transforms.setNodes(editor, { examples: newExamples }, { at: path });
  };

  return (
    <div {...attributes} contentEditable={false} className={classes.labelBlock}>
      <div className={classes.labelHeader}>
        <div className={classes.labelNameContainer}>
          <input
            className={classes.labelName}
            value={labelNameState}
            disabled={readOnly}
            onChange={e => {
              e.preventDefault();
              setLabelName(e.target.value);
            }}
            onBlur={e => {
              e.preventDefault();
              const path = ReactEditor.findPath(editor, element);
              // @ts-ignore
              Transforms.setNodes(editor, { labelName: labelNameState }, { at: path });
            }}
          />
        </div>
        <button
          className={classes.toggleButton}
          onClick={() => {
            setLocation({
              examples,
              path: ReactEditor.findPath(editor, element),
            });
            toggleExamples(!showExamples);
          }}
        >
          {!showExamples ? 'Show' : 'Hide'} examples ({examples.length})
        </button>
      </div>
      {examples && showExamples && (
        <ExampleLabelPreviewContainer
          readOnly={readOnly}
          examples={examples}
          element={element}
          location={location}
          setLocation={setLocation}
          setExampleModalOpen={setExampleModalOpen}
          setExampleSelectionGridOpen={setExampleSelectionGridOpen}
          handleDeleteExample={handleDeleteExample}
          hasOpenedExample={hasOpenedExample}
          projectTemplateId={projectTemplateId}
          isMigration={isMigration}
        />
      )}
      <div>{children as unknown as React.ReactNode}</div>
    </div>
  );
};

const useStyles = makeStyles({
  labelBlock: {
    background: '#f2f2f2',
    borderRadius: 8,
    margin: '16px 12px',
    padding: 16,
  },
  labelHeader: {
    display: 'flex',
  },
  labelNameContainer: {
    width: '40%',
    flexShrink: 0,
    fontWeight: 500,
  },
  labelName: {
    border: 0,
    background: '#f2f2f2',
    fontWeight: 500,
    fontSize: '16px',
    width: '100%',
  },
  toggleButton: {
    color: theme.colors.periwinkle100,
    outline: 'none',
    position: 'relative',
    marginLeft: 'auto',
    border: 'none',
    padding: '0 8px',
    height: 20,
    flexShrink: 0,
    borderRadius: 50,
    background: 'transparent',
    fontSize: 12,
    fontWeight: 500,
    cursor: 'pointer',
    transition: 'background 120ms ease-out',
    '&:hover': {
      background: 'white',
    },
    '&:disabled': {
      opacity: 0.5,
    },
  },
});
